import styled from "styled-components";

export const CreditCard = styled.img`
  width: 40px;
  margin-right: 5px;
`;
